// extracted by mini-css-extract-plugin
export default {"melodyVideo":"CL-z","isFullWidth":"DL-z","landingPageVideo":"EL-z","play":"FL-z","iframeVideo":"GL-z","playHidden":"HL-z","fullwidth":"IL-z"};